/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { MdKeyboardArrowRight, MdPreview, MdSearch } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import "../../EmployeeScreens/EMPLeavesRequest/EMPLeavesRequest.css";
import { HiDownload } from "react-icons/hi";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import {
  Apiurl,
  GetLoginRole,
  GetToken,
  formatNoOfDays,
  downloadFile,
} from "../../../Utils/utils";
import axios from "axios";
import Loader from "../../../Components/loader/loader";
import moment from "moment";
import "./EMPLeavesApproval.css";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const EMPLeavesApproval = () => {
  const [loading, setLoading] = useState(false);
  const getUserRole = GetLoginRole();
  const LoginToken = GetToken();
  const [showSidebar, setShowSidebar] = useState(true);
  const [leavesApprovalData, setLeavesApprovalData] = useState([]);
  const [leaveApprovalDuplicate, setLeaveApprovalDuplicate] = useState([]);
  const [showApproveModal, setShowApproveModal] = useState("");
  const [showRejectModal, setShowRejectModal] = useState("");
  const [rejectLeave, setRejectLeave] = useState("");
  const [rejectReasonLength, setRejectReasonLength] = useState(100);

  const [expandedReasons, setExpandedReasons] = useState({});
  const [expandedRejectedReasons, setExpandedRejectedReasons] = useState({});
  const [isCompactView, setIsCompactView] = useState(window.innerWidth <= 1024);

  const GetLeavesApproval = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/GetApprovalLeaves`,
    };

    axios(option)
      .then((response) => {
        setLoading(false);
        const data = JSON.parse(response?.data?.data);
        setLeavesApprovalData(data);
        setLeaveApprovalDuplicate(data);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    GetLeavesApproval();
  }, []);

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsCompactView(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDataSearch = (e) => {
    const searchData = e?.target?.value?.toLowerCase()?.trim();

    if (searchData) {
      const filterData = leaveApprovalDuplicate?.filter((item) =>
        item?.User?.UserName?.toLowerCase()?.includes(searchData)
      );
      setLeavesApprovalData(filterData);
    } else {
      setLeavesApprovalData(leaveApprovalDuplicate);
    }
  };

  const handleRejectLeave = () => {
    if (!rejectLeave || rejectLeave.trim() === "") {
      toast.error("Please enter Reason");
      return;
    }

    setLoading(true);
    const data = {};
    data.Id = showRejectModal;
    data.RejectionReason = rejectLeave;

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/RejectLeave`,
      data: { data: JSON.stringify(data) },
    };

    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setShowRejectModal("");
          setRejectLeave("");
          GetLeavesApproval();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const handleApproveLeave = () => {
    setLoading(true);
    const data = {};
    data.Id = showApproveModal;

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/ApproveLeave`,
      data: { data: JSON.stringify(data) },
    };

    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setShowApproveModal("");
          GetLeavesApproval();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const toggleExpandableText = (id, type = "reason") => {
    if (type === "reason") {
      setExpandedReasons((prev) => ({
        ...prev,
        [id]: !prev[id],
      }));
    } else {
      setExpandedRejectedReasons((prev) => ({
        ...prev,
        [id]: !prev[id],
      }));
    }
  };

  const renderExpandableText = (text, id, type = "reason", limit = 35) => {
    if (!text || text === "") return "-";

    if (!isCompactView) {
      return text;
    }

    const expanded =
      type === "reason" ? expandedReasons[id] : expandedRejectedReasons[id];

    if (text.length <= limit) {
      return <span className="leave-reason-expand-text">{text}</span>;
    }

    return (
      <div className="leave-reason-expand-wrapper">
        <span className="leave-reason-expand-text">
          {expanded ? text : `${text.slice(0, limit)}...`}
        </span>
        <button
          type="button"
          className="leave-read-toggle-btn"
          onClick={() => toggleExpandableText(id, type)}
        >
          {expanded ? "Read Less" : "Read More"}
        </button>
      </div>
    );
  };

  const getStatusClass = (status) => {
    if (
      status === "Pending At Admin" ||
      status === "Pending At HR" ||
      status === "Pending At Team Lead" ||
      status === "YetToBeApprovedByAdmin" ||
      status === "YetToBeApprovedByHR" ||
      status === "YetToBeApprovedByTeamLead"
    ) {
      return "EMP-status-pending";
    }

    if (
      status === "Cancelled" ||
      status === "Rejected By Team Lead" ||
      status === "Rejected By HR" ||
      status === "Rejected By Admin"
    ) {
      return "EMP-status-rejected";
    }

    if (
      status === "Approved By Admin" ||
      status === "ApprovedByAdmin" ||
      status === "ApprovedByHR" ||
      status === "ApprovedByTeamLead"
    ) {
      return "EMP-status-approved";
    }

    return "EMP-status-pending";
  };

  return (
    <>
      {loading ? <Loader /> : null}

      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "EMP-main-container-of-all-employees-page"
              : "EMP-main-container-of-all-employees-page-new"
          }
        >
          <div className="EMp-inner-container-of-all-employees-page">
            <div className="EMP-header-of-employees-page row">
              <div className="EMP-all-employee-text col">
                <h4>Leave Approval</h4>
              </div>

              <div className="EMP-all-employees-directory col">
                <div className="EMP-home-icon-header">
                  <BiHomeAlt className="EMP-home-icon-header-inn" />
                </div>
                <div className="EMP-arrow-icon-header">
                  <MdKeyboardArrowRight />
                </div>
                <div className="EMp-leave-employee-text-header">
                  <p>Leave Management</p>
                </div>
                <div className="arrow-icon-header">
                  <MdKeyboardArrowRight />
                </div>
                <div className="EMP-all-employee-text-header">
                  <p>Leave Approval</p>
                </div>
              </div>
            </div>
          </div>

          <div className="EMP-body-part-outer-container">
            <div className="EMP-inner-body-container-of-employee-table row-12">
              <div className="first-side-in-body-header col-6">
                <div className="EMP-employee-text-in-body">
                  <h2>Leave Requests</h2>
                </div>

                <div className="EMP-input-for-search-in-employee-body search-input-mobile-wrap">
                  <MdSearch className="EMP-search-icon-in-input" />
                  <input
                    type="text"
                    placeholder="Search by name"
                    onChange={(e) => handleDataSearch(e)}
                  />
                </div>
              </div>
            </div>

            <div className="main-class-for-table-in-leavemanagement">
              <table className="table-of-employee-leaves table-of-employee-approval">
                <thead className="thead-of-emp-table-leaves">
                  <tr>
                    <th className="approve_Sr">Sr. No.</th>
                    <th className="approve_Name">Employee Name</th>
                    <th className="approve_Date">Date</th>
                    <th className="approve_Type">Leave Type</th>
                    <th className="approve_From">Leave From</th>
                    <th className="approve_To">Leave To</th>
                    <th className="approve_Days">No Of Days</th>
                    <th className="approve_Reason">Reason</th>
                    <th className="approve_Status">Status</th>

                    {getUserRole === "HR" && (
                      <th className="approve_Reason">
                        Rejected Team Lead Reason
                      </th>
                    )}

                    {getUserRole === "Manager" ? null : (
                      <th className="approve_Action">Action</th>
                    )}
                  </tr>
                </thead>

                <tbody className="tbody-ofemp-table-leaves">
                  {leavesApprovalData?.length ? (
                    <>
                      {leavesApprovalData
                        ?.sort((a, b) => {
                          const startDateA = moment(
                            a?.StartDate,
                            "DD MMM YYYY"
                          ).valueOf();
                          const startDateB = moment(
                            b?.StartDate,
                            "DD MMM YYYY"
                          ).valueOf();
                          return startDateA - startDateB;
                        })
                        ?.map((item, index) => (
                          <tr className="tbody-approval-leaves" key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.User?.UserName}</td>
                            <td>
                              {item?.AppliedDate
                                ? moment(item?.AppliedDate).format("DD MMM YYYY")
                                : "-"}
                            </td>
                            <td>{item?.LeaveTypes?.Name}</td>
                            <td>
                              {item?.StartDate
                                ? moment(item?.StartDate).format("DD MMM YYYY")
                                : "-"}
                            </td>
                            <td>
                              {item?.EndDate
                                ? moment(item?.EndDate).format("DD MMM YYYY")
                                : "-"}
                            </td>
                            <td>{formatNoOfDays(item?.NumberofDays)}</td>

                            <td>
                              {renderExpandableText(
                                item?.Reason || "-",
                                item?.Id || `reason-${index}`,
                                "reason"
                              )}
                            </td>

                            <td>
                              <button className={getStatusClass(item?.Status)}>
                                {item?.Status}
                              </button>
                            </td>

                            {getUserRole === "HR" && (
                              <>
                                <td>
                                  {renderExpandableText(
                                    item?.RejectionReason || "-",
                                    item?.Id || `rejected-${index}`,
                                    "rejectedReason"
                                  )}
                                </td>

                                <td>
                                  <div
                                    className="button_approve_leave"
                                    style={{
                                      display: "flex",
                                      gap: "8px",
                                      alignItems: "center",
                                    }}
                                  >
                                    {item?.Status === "ApprovedByTeamLead" ||
                                    item?.Status === "Pending At HR" ? (
                                      <>
                                        <button
                                          className="EMP-Approve-table-Approved-button"
                                          onClick={() =>
                                            setShowApproveModal(item?.Id)
                                          }
                                        >
                                          Approve
                                        </button>
                                        <button
                                          className="EMP-Approve-table-Rejected-button"
                                          onClick={() =>
                                            setShowRejectModal(item?.Id)
                                          }
                                        >
                                          Reject
                                        </button>
                                      </>
                                    ) : (
                                      <div className="empty_leave_approval">
                                        -
                                      </div>
                                    )}

                                    {item?.LeaveTypes?.Name === "Sick Leave" &&
                                      (() => {
                                        const medicalDocs =
                                          item?.LeaveDocument ||
                                          item?.leaveDocument ||
                                          item?.MedicalDocuments ||
                                          item?.medicalDocuments ||
                                          [];

                                        return medicalDocs &&
                                          medicalDocs.length > 0 ? (
                                          <>
                                            {medicalDocs.map((doc, docIndex) => {
                                              const fileUrl =
                                                doc?.FilePath || doc;

                                              return (
                                                <div
                                                  key={docIndex}
                                                  style={{
                                                    display: "flex",
                                                    gap: "10px",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <button
                                                    title={`Preview Medical Bill ${
                                                      docIndex + 1
                                                    }`}
                                                    onClick={() =>
                                                      window.open(
                                                        fileUrl,
                                                        "_blank"
                                                      )
                                                    }
                                                    style={{
                                                      background: "#f0f0f0",
                                                      border: "1px solid #ccc",
                                                      borderRadius: "4px",
                                                      padding: "6px 10px",
                                                      cursor: "pointer",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      color: "#333",
                                                      fontSize: "13px",
                                                    }}
                                                  >
                                                    <MdPreview
                                                      style={{
                                                        marginRight: "4px",
                                                        fontSize: "16px",
                                                      }}
                                                    />
                                                  </button>

                                                  <button
                                                    title={`Download Medical Bill ${
                                                      docIndex + 1
                                                    }`}
                                                    onClick={() => {
                                                      downloadFile(
                                                        fileUrl,
                                                        `Medical-Bill-${
                                                          docIndex + 1
                                                        }`
                                                      );
                                                    }}
                                                    style={{
                                                      background: "#f0f0f0",
                                                      border: "1px solid #ccc",
                                                      borderRadius: "4px",
                                                      padding: "6px 10px",
                                                      cursor: "pointer",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      color: "#333",
                                                      fontSize: "13px",
                                                    }}
                                                  >
                                                    <HiDownload
                                                      style={{
                                                        marginRight: "4px",
                                                        fontSize: "16px",
                                                      }}
                                                    />
                                                  </button>
                                                </div>
                                              );
                                            })}
                                          </>
                                        ) : null;
                                      })()}
                                  </div>
                                </td>
                              </>
                            )}

                            {getUserRole !== "HR" && (
                              <td>
                                <div
                                  className="button_approve_leave"
                                  style={{
                                    display: "flex",
                                    gap: "8px",
                                    alignItems: "center",
                                  }}
                                >
                                  {getUserRole === "Manager" ? (
                                    <div className="empty_leave_approval"></div>
                                  ) : item?.Status === "Rejected By HR" ||
                                    item?.Status === "Pending At Admin" ||
                                    item?.Status === "Pending At HR" ? (
                                    <>
                                      <button
                                        className="EMP-Approve-table-Approved-button"
                                        onClick={() =>
                                          setShowApproveModal(item?.Id)
                                        }
                                      >
                                        Approve
                                      </button>
                                      <button
                                        className="EMP-Approve-table-Rejected-button"
                                        onClick={() =>
                                          setShowRejectModal(item?.Id)
                                        }
                                      >
                                        Reject
                                      </button>
                                    </>
                                  ) : (
                                    <div className="empty_leave_approval"></div>
                                  )}

                                  {item?.LeaveTypes?.Name === "Sick Leave" &&
                                    (() => {
                                      const medicalDocs =
                                        item?.LeaveDocument ||
                                        item?.leaveDocument ||
                                        item?.MedicalDocuments ||
                                        item?.medicalDocuments ||
                                        [];

                                      return medicalDocs &&
                                        medicalDocs.length > 0 ? (
                                        <>
                                          {medicalDocs.map((doc, docIndex) => {
                                            const fileUrl = doc?.FilePath || doc;

                                            return (
                                              <div
                                                key={docIndex}
                                                style={{
                                                  display: "flex",
                                                  gap: "10px",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <button
                                                  title={`Preview Medical Bill ${
                                                    docIndex + 1
                                                  }`}
                                                  onClick={() =>
                                                    window.open(
                                                      fileUrl,
                                                      "_blank"
                                                    )
                                                  }
                                                  style={{
                                                    background: "#f0f0f0",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    padding: "6px 10px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    color: "#333",
                                                    fontSize: "13px",
                                                  }}
                                                >
                                                  <MdPreview
                                                    style={{
                                                      marginRight: "4px",
                                                      fontSize: "16px",
                                                    }}
                                                  />
                                                </button>

                                                <button
                                                  title={`Download Medical Bill ${
                                                    docIndex + 1
                                                  }`}
                                                  onClick={() => {
                                                    downloadFile(
                                                      fileUrl,
                                                      `Medical-Bill-${
                                                        docIndex + 1
                                                      }`
                                                    );
                                                  }}
                                                  style={{
                                                    background: "#f0f0f0",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    padding: "6px 10px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    color: "#333",
                                                    fontSize: "13px",
                                                  }}
                                                >
                                                  <HiDownload
                                                    style={{
                                                      marginRight: "4px",
                                                      fontSize: "16px",
                                                    }}
                                                  />
                                                </button>
                                              </div>
                                            );
                                          })}
                                        </>
                                      ) : null;
                                    })()}
                                </div>
                              </td>
                            )}

                            {getUserRole === "TeamLead" && (
                              <td>
                                <div className="button_approve_leave">
                                  {item?.Status === "Pending At Team Lead" ? (
                                    <>
                                      <button
                                        className="EMP-Approve-table-Approved-button"
                                        onClick={() =>
                                          setShowApproveModal(item?.Id)
                                        }
                                      >
                                        Approve
                                      </button>
                                      <button
                                        className="EMP-Approve-table-Rejected-button"
                                        onClick={() =>
                                          setShowRejectModal(item?.Id)
                                        }
                                      >
                                        Reject
                                      </button>
                                    </>
                                  ) : (
                                    <div className="empty_leave_approval">-</div>
                                  )}
                                </div>
                              </td>
                            )}
                          </tr>
                        ))}
                    </>
                  ) : (
                    <tr className="no-record-found-tr-dashboard">
                      <td colSpan="10">No record found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {showRejectModal && (
        <div
          className="modal show edit-leaveModal"
          style={{ display: "block" }}
        >
          <Modal.Dialog>
            <Modal.Header
              className="delete-modal-header"
              closeButton
              onClick={() => setShowRejectModal("")}
            >
              <Modal.Title>Reject Confirmation</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="textarea-validate">
                <label htmlFor="">Reason</label>
                <textarea
                  type="text"
                  className="textarea-for-delete-leave-api"
                  maxLength={100}
                  value={rejectLeave}
                  onChange={(e) => setRejectLeave(e?.target?.value)}
                />

                {rejectLeave ? (
                  <div className="character_left_leave_approval">
                    {rejectReasonLength - rejectLeave?.length} characters left
                  </div>
                ) : (
                  <div className="character_left_leave_approval">
                    100 characters left
                  </div>
                )}
              </div>
            </Modal.Body>

            <Modal.Footer className="Delete-fotter">
              <button
                className="Delete-modal-close-button"
                onClick={() => setShowRejectModal("")}
              >
                Close
              </button>
              <button
                className="Delete-modal-delete-button"
                onClick={() => handleRejectLeave()}
              >
                Reject
              </button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}

      {showApproveModal && (
        <div
          className="modal show edit-leaveModal"
          style={{ display: "block" }}
        >
          <Modal.Dialog>
            <Modal.Header
              className="delete-modal-header"
              closeButton
              onClick={() => setShowApproveModal("")}
            >
              <Modal.Title>Approve Confirmation</Modal.Title>
            </Modal.Header>

            <Modal.Footer className="Delete-fotter">
              <button
                className="Delete-modal-close-button"
                onClick={() => setShowApproveModal("")}
              >
                Close
              </button>
              <button
                className="Delete-modal-delete-button"
                onClick={() => handleApproveLeave()}
              >
                Approve
              </button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}
    </>
  );
};

export default EMPLeavesApproval;